import React from "react";
import useToggle from "../../../hooks/useToggle";
import GoToTop from "../../Helpers/GoToTop";
import Drawer from "../../Mobile/Drawer";
import FooterOne from "../../Partials/Footers/FooterOne";
import HeaderOne from "../../Partials/Headers/HeaderOne";
import SettingsForBigScreen from "./SettingsForBigScreen";
import SettingsForMobileScreen from "./SettingsForMobileScreen";

function ConnectWallet() {
  const [drawer, setDrawer] = useToggle(false);

  return (
    <>
      <Drawer drawer={drawer} action={setDrawer.toggle} />
      <HeaderOne className="shop-page-header" action={setDrawer.toggle} />
      <SettingsForBigScreen />
      <SettingsForMobileScreen />
      <FooterOne />
      <GoToTop />
    </>
  );
}

export default ConnectWallet;
